import React from "react";
import { Search, Sparkles, Plus, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { UserAvatar } from "@/components/common";
import { MediabilityMark } from "@/components/Logo";

/**
 * The app's top bar: search (command palette), Ask AI, New in Workspace, profile.
 * Purely presentational - the shell wires the callbacks. Also used by static previews.
 */
export function Topbar({ user, onMenu, onSearch, onAI, onNew, onProfile, className }) {
  return (
    <header className={`flex h-16 shrink-0 items-center justify-between gap-3 bg-background px-3 sm:px-6 ${className || ""}`} data-testid="topbar">
      <div className="flex min-w-0 items-center gap-2">
        <Button variant="ghost" size="icon" className="lg:hidden" onClick={onMenu} data-testid="mobile-nav-button" aria-label="Open navigation">
          <Menu className="h-5 w-5" />
        </Button>
        <span className="lg:hidden"><MediabilityMark className="h-6 w-6" /></span>
        <button
          type="button"
          data-testid="command-palette-trigger-button"
          onClick={onSearch}
          className="group hidden h-10 w-64 items-center gap-2.5 rounded-full border border-black/[0.07] bg-white px-4 text-[13px] text-muted-foreground shadow-[0_1px_2px_hsl(30_12%_18%/0.04)] hover:border-black/[0.16] hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/40 sm:flex md:w-80 lg:w-[440px]"
        >
          <Search className="h-4 w-4 text-muted-foreground/80" />
          <span className="flex-1 truncate text-left">Search customers, opportunities, quotes…</span>
          <span className="kbd">⌘K</span>
        </button>
        <Button variant="ghost" size="icon" className="sm:hidden" onClick={onSearch} data-testid="command-palette-trigger-mobile-button" aria-label="Search">
          <Search className="h-5 w-5" />
        </Button>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" className="hidden gap-2 rounded-full md:inline-flex" onClick={onAI} data-testid="ai-assistant-open-button">
          <Sparkles className="h-4 w-4 text-primary" /> Ask AI
        </Button>
        <Button className="gap-2 rounded-full" onClick={onNew} data-testid="new-inquiry-button">
          <Plus className="h-4 w-4" /> <span className="hidden sm:inline">New in Workspace</span><span className="sm:hidden">New</span>
        </Button>
        <button type="button" onClick={onProfile} className="ml-1.5 rounded-full ring-offset-2 ring-offset-background transition-transform duration-150 hover:scale-[1.04] focus-visible:ring-2 focus-visible:ring-ring/50" data-testid="topbar-profile-button" aria-label="Profile and settings">
          <UserAvatar name={user?.name} initials={user?.initials} color={user?.color} src={user?.avatar_url} size="lg" className="h-9 w-9" testId="topbar-user-avatar" />
        </button>
      </div>
    </header>
  );
}
